import { useState } from 'react';
import { plataformaAnuncio, previewAnuncio } from './ctwa.utils';

const PLATFORM_BG = {
    instagram: 'linear-gradient(145deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)',
    facebook: 'linear-gradient(145deg, #1877f2 0%, #0e5fc7 100%)',
    meta: 'linear-gradient(145deg, #25d366 0%, #0f8f72 100%)',
};

const PLATFORM_LABEL = {
    instagram: 'IG',
    facebook: 'FB',
    meta: 'WA',
};

export default function CtwaAnuncioThumb({ anuncio, titulo, size = 'md' }) {
    const [erro, setErro] = useState(false);
    const preview = previewAnuncio(anuncio);
    const plataforma = plataformaAnuncio(anuncio.source_url);
    const mostrarImg = preview && !erro;
    const dim = size === 'sm' ? 'w-11 h-11' : 'w-14 h-14';
    const label = PLATFORM_LABEL[plataforma.id] || 'AD';

    return (
        <div
            className={`${dim} rounded-md overflow-hidden flex-shrink-0 border border-[#e6e6ec]`}
            style={{ background: mostrarImg ? '#f4f4f6' : PLATFORM_BG[plataforma.id] || PLATFORM_BG.meta }}
        >
            {mostrarImg ? (
                <img
                    src={preview}
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    onError={() => setErro(true)}
                />
            ) : (
                <div className="w-full h-full flex flex-col items-center justify-center text-white select-none leading-none">
                    <span className="text-[11px] font-extrabold tracking-wide">{label}</span>
                    {anuncio.media_type && (
                        <span className="text-[8px] font-bold uppercase opacity-80 mt-0.5">
                            {anuncio.media_type === 'video' ? 'VID' : 'IMG'}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}
